var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.72 7.69h32.06v10.42h-32.06z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00579f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.61 18h-2.61l1.64-10.13h2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 8.11a6.51 6.51 0 0 0 -2.33-.42c-2.56 0-4.37 1.37-4.38 3.33 0 1.45 1.29 2.26 2.27 2.74s1.35.81 1.35 1.25c0 .68-.81 1-1.56 1a5.24 5.24 0 0 1 -2.44-.53l-.34-.17-.36 2.27a7.85 7.85 0 0 0 2.9.53c2.72 0 4.49-1.35 4.52-3.44 0-1.15-.69-2-2.18-2.75-.91-.46-1.47-.77-1.47-1.24s.47-.87 1.5-.87a4.32 4.32 0 0 1 1.93.39l.24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.48 14.38c.22-.58 1-2.82 1-2.82l.34-1 .18.87s.49 2.42.6 2.92zm3.21-6.51h-2a1.29 1.29 0 0 0 -1.36.83l-3.87 9.3h2.73s.45-1.24.54-1.51h3.34c.07.36.31 1.51.31 1.51h2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.85 7.87-2.54 6.88-.31-1.4a7.74 7.74 0 0 0 -3.56-4.23l2.33 8.82h2.74l4.08-10.07z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.94 7.87h-4.17v.2a8.73 8.73 0 0 1 6.23 5.28l-.88-4.63a1.07 1.07 0 0 0 -1.18-.85z",
    fill: "#faa61a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.6c39a7a0cf19293f722f18403d15f694.svg";
export { ForwardRef as ReactComponent };